import { getLtcCostRoundingStep } from '@shared';
import { useSelector } from 'react-redux';
import { useFeatureFlags } from '@client/contexts/FeatureFlagsContext';
import { selectMaybeClient, selectSessionAdvisor } from '@client/model/selectors';

export type LtcCostRoundingStep = 0 | 10 | 100 | 1000;

/**
 * Returns the rounding step for projected LTC cost display (0 = precise, 10 | 100 | 1000 = round to that step).
 * When ltcCostRoundingOptions flag is off, always returns 0 (precise). When on, uses advisor setting; default precise.
 */
export function useLtcCostDisplayPrecision(): LtcCostRoundingStep {
  const { flags } = useFeatureFlags();
  const client = useSelector(selectMaybeClient);
  const advisor = useSelector(selectSessionAdvisor);

  if (!flags.ltcCostRoundingOptions) {
    return 0;
  }
  const precision =
    client?.clientAdvisorSettings?.ltcCostDisplayPrecision ??
    advisor?.ltcCostDisplayPrecision;
  return getLtcCostRoundingStep(precision);
}
